/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { ref, onMounted, onUnmounted } from 'vue';
import { isServer } from '../utils/dom.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-2684fd15.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../utils/easing.mjs';

var useMouse = function useMouse() {
  var x = ref(0);
  var y = ref(0);

  var onMouseMove = function onMouseMove(e) {
    x.value = e.clientX;
    y.value = e.clientY;
  };

  if (!isServer) {
    onMounted(function () {
      window.addEventListener("mousemove", onMouseMove, {
        passive: true
      });
    });
    onUnmounted(function () {
      window.removeEventListener("mousemove", onMouseMove);
    });
  }

  return {
    x: x,
    y: y
  };
};

export { useMouse };
//# sourceMappingURL=util.mjs.map
